import React, { useState, useEffect } from 'react';

import { useGetAnaerobicThreshold } from 'api/services';
import ChartModal from 'components/ChartModal/ChartModal';
import { chartsKey } from 'utils/constants';

import { getGradientBackground } from './utils/chartColorizing';
import {
	defaultChartAxisValues,
	handleChartData,
	increaseOrDecreaseMaxYThreshold,
	getChartMaxValue,
	getChartMinValue,
} from './utils/chartHelpers';
import {
	defaultConfig,
	ticksCallbackBPM,
	tooltipCallbackBPM,
	styledChartElements,
} from './utils/customViewChart';

const AnaerobicThreshold = ({ closeChart, isOpen }) => {
	const [data, setData] = useState({});
	const [chartConfig, setChartConfig] = useState(null);
	const [labelsData, setLabelsData] = useState(undefined);

	const { data: anaerobicThresholdData, loading } = useGetAnaerobicThreshold();
	const isDataAvailable =
		anaerobicThresholdData?.data && anaerobicThresholdData.data.length > 0;

	useEffect(() => {
		if (isDataAvailable) {
			const dataAdapted = handleChartData(anaerobicThresholdData.data);

			setData(dataAdapted);
			setLabelsData(dataAdapted?.labels);
			handleChartConfig();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [anaerobicThresholdData]);

	const handleChartConfig = () => {
		let minY = defaultChartAxisValues[chartsKey.anaerobicThreshold].minY;
		let maxY = defaultChartAxisValues[chartsKey.anaerobicThreshold].maxY;

		const minValueOfY = getChartMinValue(anaerobicThresholdData.data, 'value');
		const maxValueOfY = getChartMaxValue(anaerobicThresholdData.data, 'value');

		if (maxValueOfY && maxValueOfY >= maxY) {
			maxY = maxValueOfY + increaseOrDecreaseMaxYThreshold.large;
		}

		if (minValueOfY && minValueOfY <= minY) {
			minY = minValueOfY - increaseOrDecreaseMaxYThreshold.xl;
		}

		const config = {
			...defaultConfig,
			plugins: {
				...defaultConfig.plugins,
				tooltip: {
					...defaultConfig.plugins.tooltip,
					callbacks: { label: tooltipCallbackBPM },
				},
			},
			elements: styledChartElements(anaerobicThresholdData.data.length - 1),
			scales: {
				...defaultConfig.scales,
				y: {
					...defaultConfig.scales.y,
					min: minY,
					max: maxY,
					ticks: {
						...defaultConfig.scales.y.ticks,
						callback: ticksCallbackBPM,
					},
				},
			},
		};

		setChartConfig(config);
	};

	const getChartData = (canvas) => {
		const gradient = getGradientBackground(canvas);

		return {
			...data,
			datasets: [
				{
					data: data?.datasets[0]?.data,
					beginAtZero: true,
					fill: true,
					backgroundColor: gradient,
				},
			],
		};
	};

	return (
		<ChartModal
			loading={loading}
			data={getChartData}
			labelsData={labelsData}
			closeChart={closeChart}
			chartConfig={chartConfig}
			isOpen={isOpen}
		/>
	);
};

export default AnaerobicThreshold;
